import styled from 'styled-components';

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
`

export const FormBox = styled.form`
    width: 100%;
    max-width: 700px;
    padding: 40px;
    background-color: #bbb;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 5px 5px 10px 1px #000;
`

export const FormInput = styled.input`
    display: block;
    width: 100%;
    background-color: #ddd;
    height: 40px;
    border-radius: 5px;
    border: 1px solid #ddd;
    margin: 10px 0 20px 0;
    padding: 20px;
    box-sizing: border-box;
`

export const FormSelect = styled.select`
    display: flex;
    position: relative;
    width: 100%;
    background-color: #ddd;
    height: 40px;
    border-radius: 5px;
    border: 1px solid #ddd;
    margin: 10px 0 20px 0;
    padding: 20px;
    box-sizing: border-box;
    
`

export const TextStyle = styled.text`
    color: black;
`

export const FormTextArea = styled.textarea`

`

export const FieldSet = styled.fieldset`

`

//RYE//

export const Errors = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    color: red;
    font-size: 20px;
    margin-top: 0px;
`